import { PageLayout } from '@/components/molecules/pageLayout';
import { HeaderTitleConfig } from '@/types/dashboard';
import { SearchButtons } from '@/components/organisms/welcome/buttons';
import { Desktop } from '../viewport/desktop';
import { Mobile } from '../viewport/mobile';
import { MenuButton, MenuButtonOption } from '../button/menu';
import { useTranslation } from '@/hooks/useTranslation';
import { FileDownloadOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { DownloadUsage } from '@/graphql/types/downloads';

/**
 * @deprecated This component is deprecated. Use the unified header system through
 * PrivateRoute.headerConfig instead. This component will be removed in a future version.
 */
interface CustomHeaderProps {
  headerTitle: (cityName?: string) => HeaderTitleConfig;
  onMunicipalitySearch?: () => void;
  onAdvancedSearch?: () => void;
  downloadOptions?: MenuButtonOption[];
  showSearchButtons?: boolean;
  hasBaseHeaderMargin?: boolean;
  loading?: boolean;
  downloadUsage?: DownloadUsage;
  limitReachedMessage?: string;
}

/**
 * @deprecated This component is deprecated. Use the unified header system through
 * PrivateRoute.headerConfig instead. This component will be removed in a future version.
 */
export const CustomHeader = ({
  headerTitle,
  onMunicipalitySearch,
  onAdvancedSearch,
  downloadOptions,
  showSearchButtons = false,
  hasBaseHeaderMargin = false,
  loading = false,
  downloadUsage,
  limitReachedMessage,
}: CustomHeaderProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { t } = useTranslation();

  return (
    <>
      <PageLayout.Background>
        <PageLayout.Header
          title={headerTitle().title}
          onBack={headerTitle().onClick}
          hasBaseMargin={hasBaseHeaderMargin}
        >
          <Mobile>
            {/* Download button mobile */}
            {downloadOptions && downloadOptions.length > 0 && (
              <MenuButton
                loading={loading}
                options={downloadOptions || []}
                icon={FileDownloadOutlined}
                label={isMobile ? undefined : t('button.button.export')}
                isHeader
                downloadUsage={downloadUsage}
                limitReachedMessage={limitReachedMessage}
              />
            )}
          </Mobile>

          <Desktop>
            {/* Search buttons */}
            {showSearchButtons && (
              <SearchButtons
                onMunicipalitySearch={onMunicipalitySearch}
                onAdvancedSearch={onAdvancedSearch}
                height="36px"
              />
            )}

            {/* Download button desktop */}
            {downloadOptions && downloadOptions.length > 0 && (
              <MenuButton
                label={t('button.button.export')}
                startIcon={FileDownloadOutlined}
                loading={loading}
                options={downloadOptions}
                downloadUsage={downloadUsage}
                limitReachedMessage={limitReachedMessage}
              />
            )}
          </Desktop>
        </PageLayout.Header>
      </PageLayout.Background>
    </>
  );
};
